module.exports = __webpack_public_path__ + "static/img/SKG.ada16fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/SKG.jpg
// module id = Hd3p
// module chunks = 0